import { useEffect } from 'react';
import { referralService } from '@/services/referralService';

/**
 * Hook to automatically capture and persist referral codes and UTM params
 * Place this in App.tsx or a top-level layout component
 * 
 * Now uses localStorage for true 30-day persistence across browser sessions
 */
export const useReferralTracking = () => {
  useEffect(() => {
    // Check for referral code in URL
    const params = new URLSearchParams(window.location.search);
    const refCode = params.get('ref');
    
    if (refCode) {
      console.log('[Referral Hook] Found referral code in URL:', refCode);
      referralService.persistReferralCode(refCode);
    }

    // Always persist UTM params
    referralService.persistUTMParams();
    
    // Log current stored code and plan (if any)
    const storedCode = referralService.extractReferralCode();
    const storedPlan = referralService.getSelectedPlan();
    if (storedCode) {
      console.log('[Referral Hook] Active referral code:', storedCode);
    }
    if (storedPlan) {
      console.log('[Referral Hook] Selected plan:', storedPlan);
    }
  }, []); // Run once on mount
};
